import { featureFlagSelector } from '@doda/common/src/redux/features/featureFlag';
import { useAppSelector } from '@doda/pc/src/redux/hooks';
import { RootState } from '@doda/pc/src/redux/store';

export const useFeatureFlag = ({
  applicationName,
  configurationName,
  flagName,
}: {
  applicationName: string;
  configurationName: string;
  flagName: string;
}) => {
  const featureFlag = useAppSelector((state: RootState) =>
    featureFlagSelector(state.featureFlag, {
      applicationName,
      configurationName,
      flagName,
    })
  );

  return featureFlag?.isEnabled ?? false;
};
